import { useEffect } from 'react';

export default function MainStyles() {
  useEffect(() => {
    // Load main frontend CSS files dynamically
    const loadCSS = (href) => {
      // Check if link already exists (check both with and without leading slash)
      const normalizedHref = href.startsWith('/') ? href : `/${href}`;
      const existingLink = document.querySelector(`link[href="${href}"], link[href="${normalizedHref}"]`);
      if (existingLink) {
        // Ensure it's in the head if it exists
        if (existingLink.parentNode !== document.head) {
          document.head.appendChild(existingLink);
        }
        return existingLink;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.setAttribute('data-main-frontend-css', 'true'); // Mark for identification
      document.head.appendChild(link);
      return link;
    };

    // Load CSS files - use absolute paths (starting with /) to work from any route
    const cssFiles = [
      '/css/bootstrap.min.css',
      '/css/style.css',
      '/css/plugin.css',
      '/css/fontawesome.min.css',
      '/fonts/line-icons.css',
    ];

    // Load external CSS
    const externalCSS = {
      href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/7.0.1/css/all.min.css',
      integrity: 'sha512-2SwdPD6INVrV/lHTZbO2nodKhrnDdJK9/kg2XD1r9uGqPo1cUbujc+IYdlYdEErWNu69gVcYgdxlmVmzTWnetw==',
      crossOrigin: 'anonymous',
    };

    // Load all CSS
    const loadedCSS = cssFiles.map((href) => loadCSS(href));

    // Load external CSS
    const externalLink = loadCSS(externalCSS.href);
    if (externalCSS.integrity) {
      externalLink.integrity = externalCSS.integrity;
    }
    if (externalCSS.crossOrigin) {
      externalLink.crossOrigin = externalCSS.crossOrigin;
    }
    loadedCSS.push(externalLink);

    // Don't remove CSS on cleanup - it should persist across route changes
    // Only cleanup if navigating away from main frontend entirely
    return () => {
      // CSS will persist - no cleanup needed
      // This ensures CSS stays loaded when navigating between main frontend pages
    };
  }, []);

  return null;
}
